export default "__VITE_ASSET__CD8Vt$$S__"